import { STATUS } from '@kontentino/kontentino-constants/Posts';

const GROUP_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
  POST_UPDATE_MANUAL: 'post_update_manual',
};

const ACTIONS = {
  ADD: 'add',
  CHANGE: 'change',
  REMOVE: 'remove',
};

const ACTIONS_LABELS = {
  ADD: 'added',
  CHANGE: 'changed',
  REMOVE: 'removed',
};

const ATTRIBUTES = {
  POST_TEXT: 'post_text',
  POST_TRANSLATION: 'post_translation',
  POST_LABELS: 'post_labels',
  POST_STATUS: 'post_status',
  POST_STATUS_MANUAL: 'post_status_manual',
  POST_AUDIENCE_RESTRICTIONS: 'post_audience_restrictions',
  POST_LINK_DESCRIPTION: 'post_link_description',
  POST_LINK: 'post_link',
  POST_LINK_TITLE: 'post_link_title',
  POST_LINK_CAPTION: 'post_link_caption',
  POST_LINK_CTA: 'post_link_cta',
  POST_LINK_IMAGE: 'post_link_image',
  POST_VIDEOS: 'post_videos',
  POST_PHOTOS: 'post_photos',
  POST_PROJECT: 'post_project',
  POST_DATE: 'post_date',
  POST_TIME: 'post_time',
  POST_CLONE_PARENT: 'post_clone_parent',
  POST_NOTE: 'post_note',
  POST_FIRST_COMMENT: 'first_comment',
  PUBLISHING_METHOD: 'publishing_method',
  SHARE_TO_FEED: 'share_to_feed',
  VIDEO_THUMBNAIL: 'video_thumbnail',
};

const ATTRIBUTES_VALUES = Object.values(ATTRIBUTES);

const ATTRIBUTE_LABELS = {
  POST_TEXT: 'post text',
  POST_TRANSLATION: 'translation',
  POST_LABELS: 'labels',
  POST_STATUS: {
    [STATUS.WAITING_FOR]: 'assigned post',
    [STATUS.DONE]: 'marked as done',
    [STATUS.COMPLETED]: 'marked as draft',
    [STATUS.DRAFT]: 'marked as private draft',
    [STATUS.WAITING_FOR_INTERNAL_APPROVAL]: 'sent for internal approval',
    [STATUS.INTERNAL_APPROVED]: 'approved post',
    [STATUS.AT_CLIENT]: 'sent for client approval',
    [STATUS.APPROVED]: 'approved post',
    [STATUS.POSTED]: 'published post ',
    [STATUS.REJECTED]: 'asked for post rework',
    [STATUS.REJECTED_BY_CLIENT]: 'asked for post rework',
    [STATUS.SCHEDULED]: 'scheduled post',
    [STATUS.EXPORTED]: 'exported post',
    [STATUS.EXPORT_FAILED]: 'set status to export failed',
    [STATUS.FAILED]: 'failed post',
  },
  POST_STATUS_MANUAL: 'manually changed status to',
  POST_AUDIENCE_RESTRICTIONS: 'audience restrictions',
  POST_LINK: 'link url',
  POST_LINK_DESCRIPTION: 'link preview description',
  POST_LINK_TITLE: 'link preview title',
  POST_LINK_CAPTION: 'link preview caption',
  POST_LINK_CTA: 'link preview CTA',
  POST_LINK_IMAGE: 'link preview image',
  POST_VIDEOS: 'video',
  POST_PHOTOS: 'photos',
  POST_PROJECT: 'content plan',
  POST_TIME: 'post time',
  POST_DATE: 'post date',
  POST_NOTE: 'note',
  FIRST_COMMENT: 'first comment',
  PUBLISHING_METHOD: 'publishing method',
  SHARE_TO_FEED: 'share to feed',
  VIDEO_THUMBNAIL: 'video thumbnail',
};

export const ActivityRecordOptions = {
  ATTRIBUTES_VALUES,
  STATUS,
  ATTRIBUTES,
  ATTRIBUTE_LABELS,
  ACTIONS,
  GROUP_TYPES,
  ACTIONS_LABELS,
};
